module.exports = __webpack_public_path__ + "img/DE00896.51a532b3.png";